<div class="container">
  <div class="shield-container">
    <img [src]="'./assets/philips.png'"/>
  </div>
  <div class="product-name-container">
    <span>{{productName}}</span>
  </div>
  <div class="common-name-container">
    <span class="common-version">{{'Release' | cpLabelTranslate:[releaseVersion] | async}}</span>
  </div>

  <div class="lot-ref-container">
    <div class="lot-symbol">LOT</div>
    <span class="lot-number">{{commercialVersion}}</span>
    <div class="ref-symbol">REF</div>
    <span class="ref-number">{{productCodeNumber}}</span>
  </div>

  <div class="main-text-container">
    <div class="main-text-container-inner">
      <span [innerHTML]="'Copyright' | cpLabelTranslate:['© ' + copyrightYear] | async | cpBoldText:'© \\d+ Koninklijke Philips N.V.'"></span>
      <p>
        {{'SoftwareLicensingStatement' | cpMessageTranslate | async}}
      </p>
      <p>
        {{'ReengineeringStatement' | cpMessageTranslate | async}}
      </p>
      <div [ngClass]="{'non-medical': isNonMedicalDevice}">{{'Build' | cpLabelTranslate:[commercialVersion + '_' + buildNumber] | async}}</div>

      <span *ngIf="isNonMedicalDevice">{{'NonDiagnosticStatement' | cpLabelTranslate | async}}</span>
      <p *ngIf="isUnreleasedDevice">
        {{'WarrantyDisclaimer' | cpLabelTranslate:['Workflow Information Management', releaseVersion] | async }}
      </p>
    </div>

    <div class="manufacturer-name-address-container">
      <img [src]="'./assets/manufacture.png'" />
      <div class="name-address">
        <span>Philips Medical Systems Nederland B.V.</span>
        <span>Veenpluis 6, 5684 PC  Best, The Netherlands</span>
      </div>
    </div>
  </div>
  <div class="about-footer-container">
    <div>
      <a (click)="this.openUkImporterPopup()" class="uk-importer">{{'OtherCountryLabel' | cpLabelTranslate | async}}</a>
      <img [src]="'./assets/consult.png'" />
      <a href="https://www.philips.com/IFU" target="_blank">eIFU</a>
      <img class="caution-symbol" [ngClass]="{'unreleased' : isUnreleasedDevice}" [src]="'./assets/caution.png'" />
      <span *ngIf="isUnreleasedDevice"  class="caution-text" >{{'EvaluationPurposes' | cpLabelTranslate | async}}</span>
    </div>
    <div>
      <div class="manufacturer-date">
        <img class="manufacturer-symbol" [src]="'./assets/manufacture-date.png'" />
        <span>{{buildDate}}</span>
      </div>
      <div class="udi-hri-container" [ngClass]="{'unreleased' : isUnreleasedDevice}">
        <span>(01)00884838125292</span>
        <span>(10){{commercialVersion}}(11){{buildDateUDI}}</span>
      </div>
    </div>
  </div>
</div>

<ng-template #otherCountryLabelTitle>
  <div class="popup-title-container about">
    <h1 class="popup-title-text" id="about-title">{{'OtherCountryLabel' | cpTitleTranslate | async}}</h1>
    <i class="pp-icon-close popup-close" cpClickableElement [elementDescription]="'Close' | cpActionTranslate | async" (click)="popupWindowService.closeLatestPopup()"></i>
  </div>
</ng-template>
